module.exports = __webpack_public_path__ + "91d5daa3e73b91d2e6f5725db698eb70.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/backgrounds/carousel/qello/4.png
// module id = 851
// module chunks = 0